module.exports = __webpack_public_path__ + "7a5100377080398b0913c0838d1eb1f8.svg";